var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "klienticta pointer",
    staticStyle: {
      "margin-left": "6px"
    },
    on: {
      "click": function click($event) {
        return _vm.openShareChatPopUp();
      }
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f23_icons8-invite.svg"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }